import arLocale from 'element-ui/lib/locale/lang/ar'
import home from './ar/home'

const ar = {
    language: 'العربية',
    message: {
        'home': {
            ...home,
            enterEmail: 'الرجاء إدخال البريد الإلكتروني',
            save: 'حفظ',
            saveSuccess: 'تم الحفظ بنجاح',
            pointHistory: 'سجل النقاط',
            type: 'النوع',
            remark: 'ملاحظة',
            pendingComment: 'في انتظار التقييم',
            commented: 'تم التقييم',
            selectDate: 'اختر التاريخ',
            loginSuccess: 'تم تسجيل الدخول بنجاح',
            loginFail: 'فشل تسجيل الدخول',
            close: 'إغلاق',
            required: 'مطلوب',
            nickname: 'الاسم المستعار',
            enterNickname: 'الرجاء إدخال الاسم المستعار',
            gender: 'الجنس',
            male: 'ذكر',
            female: 'أنثى',
            secret: 'سري',
            birthday: 'تاريخ الميلاد',
            checkoutLoadFailed: 'فشل تحميل معلومات الدفع. يرجى المحاولة مرة أخرى لاحقًا.',
            checkoutErrorTitle: 'تنبيه',
            goAddAddress: 'إضافة عنوان التسليم',
            shop_order_selectOrAddAddress: 'يرجى إضافة عنوان تسليم أولاً وتعيينه كافتراضي قبل إتمام الطلب.',
            shop_order_cartEmpty: 'سلة التسوق فارغة، لا يمكن إتمام الطلب.',
            shop_order_cartHasNotActive: 'توجد منتجات غير منشورة أو غير صالحة، لا يمكن إتمام الطلب.',
            shop_order_cartHasNotMarketable: 'توجد منتجات تم سحبها، لا يمكن إتمام الطلب.',
            shop_order_cartHasLowStock: 'المخزون غير كافٍ، لا يمكن إتمام الطلب.',
            shop_order_cartHasExpiredGoods: 'انتهت صلاحية بعض منتجات المتجر، لا يمكن إتمام الطلب.',
            shop_order_typeIsNull: 'تعذر التعرف على نوع الطلب، يرجى التحقق من نوع المنتج.',
            shop_order_goodsNotFound: 'معلومات المنتج غير موجودة أو تم حذفها.',
            shop_order_giftNotForSale: 'لا يمكن شراء منتجات الهدايا مباشرة.',
            common_message_badRequest: 'طلب غير صالح، يرجى التحقق من المنتج والمعلمات.',
        },
    },
    '手机号码最小长度为8位': 'الحد الأدنى لطول رقم الهاتف المحمول هو 8 أرقام',
    '邮箱账号名称最小长度为6位': 'الحد الأدنى لطول اسم حساب البريد الإلكتروني هو 6 أحرف',
    '邮箱只能包含英文，数字等字符': 'يمكن أن يحتوي صندوق البريد فقط على اللغة الإنجليزية والأرقام والأحرف الأخرى',
    '请选择正确的收货地址': 'الرجاء تحديد عنوان التسليم الصحيح',
    Dict_language_status_0: 'معطل',
    Dict_language_status_1: 'مفعّل',
    Dict_member_label_type_1: 'علامة شرطية',
    Dict_member_label_type_2: 'علامة يدوية',
    Dict_member_level_type_0: 'مستوى الاستهلاك (LV)',
    Dict_member_level_type_1: 'عضو مدفوع (VIP)',
    Dict_member_growth_action_type_1: 'تقديم طلب',
    Dict_member_growth_action_type_2: 'تسجيل دخول يومي',
    Dict_member_growth_action_type_3: 'نشر تقييم',
    Dict_member_growth_action_type_4: 'استكمال الملف الشخصي',
    Dict_paid_member_payment_type_0: 'الدفع من الرصيد',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'ساري',
    Dict_paid_member_record_status_1: 'منتهي الصلاحية',
    Dict_paid_member_record_status_2: 'تم استرداده',
    Dict_point_lottery_prize_type_0: 'نقاط',
    Dict_point_lottery_prize_type_1: 'قسيمة',
    Dict_point_lottery_prize_type_2: 'جائزة عينية',
    Dict_point_lottery_prize_type_3: 'شكرًا لمشاركتك',
    Dict_notification_channel_type_0: 'رسالة نصية',
    Dict_notification_channel_type_1: 'بريد إلكتروني',
    Dict_notification_channel_type_2: 'رسالة داخلية',
    Dict_notification_channel_type_3: 'إشعار فوري',
    Dict_announcement_status_0: 'مسودة',
    Dict_announcement_status_1: 'منشور',
    Dict_announcement_status_2: 'تم سحبه',
    Dict_live_permission_status_0: 'لم يُقدّم طلب',
    Dict_live_permission_status_1: 'قيد المراجعة',
    Dict_live_permission_status_2: 'مُفعّل',
    Dict_live_permission_status_3: 'مرفوض',
    Dict_live_room_status_0: 'لم يبدأ',
    Dict_live_room_status_1: 'بث مباشر',
    Dict_live_room_status_2: 'انتهى',
    Dict_live_room_status_3: 'انقطاع غير طبيعي',
    Dict_live_room_type_0: 'بث المنصة',
    Dict_live_room_type_1: 'بث التاجر',
    Dict_store_type_0: 'متجر فردي',
    Dict_store_type_1: 'متجر مؤسسي',
    Dict_store_sign_status_0: 'بانتظار التوقيع',
    Dict_store_sign_status_1: 'تم التوقيع',
    Dict_store_sign_status_2: 'تم الإنهاء',
    Dict_store_business_change_status_0: 'بانتظار المراجعة',
    Dict_store_business_change_status_1: 'تمت الموافقة',
    Dict_store_business_change_status_2: 'مرفوض',
    Dict_decoration_page_type_0: 'الصفحة الرئيسية',
    Dict_decoration_page_type_1: 'صفحة التصنيف',
    Dict_decoration_page_type_2: 'صفحة الحملة',
    Dict_decoration_page_type_3: 'صفحة مخصصة',
    Dict_decoration_status_0: 'مسودة',
    Dict_decoration_status_1: 'منشور',
    Dict_decoration_popup_trigger_page_0: 'الصفحة الرئيسية للمنصة',
    Dict_decoration_popup_trigger_page_1: 'مركز الأعضاء',
    Dict_decoration_popup_trigger_page_2: 'نجح الدفع',
    Dict_decoration_popup_target_user_0: 'جميع المستخدمين',
    Dict_decoration_popup_target_user_1: 'الأعضاء المجانيون',
    Dict_decoration_popup_target_user_2: 'الأعضاء المدفوعون',
    Dict_decoration_popup_frequency_0: 'مرة واحدة بشكل دائم',
    Dict_decoration_popup_frequency_1: 'كل زيارة',
    Dict_decoration_popup_frequency_2: 'تكرار مخصص',
    Dict_track_event_type_page_view: 'مشاهدة الصفحة',
    Dict_track_event_type_click: 'نقرة',
    Dict_track_event_type_add_to_cart: 'إضافة إلى السلة',
    Dict_track_event_type_search: 'بحث',
    Dict_track_event_type_purchase: 'شراء',
    Dict_track_event_type_live_watch: 'مشاهدة البث المباشر',
    Dict_reconcile_period_type_0: 'يومي',
    Dict_reconcile_period_type_1: 'أسبوعي',
    Dict_reconcile_period_type_2: 'شهري',
    Dict_store_settlement_status_0: 'بانتظار التسوية',
    Dict_store_settlement_status_1: 'تمت التسوية',
    Dict_distributor_status_0: 'بانتظار المراجعة',
    Dict_distributor_status_1: 'تمت المراجعة',
    Dict_distributor_status_2: 'مرفوض',
    Dict_distribution_commission_type_0: 'عمولة مباشرة',
    Dict_distribution_commission_type_1: 'عمولة غير مباشرة',
    Dict_configuration_status_0: 'معطل',
    Dict_configuration_status_1: 'مفعّل',
    ...arLocale
}
export default ar